import { render, staticRenderFns } from "./confirmation-modal.component.vue?vue&type=template&id=320faafd"
import script from "./confirmation-modal.component.vue?vue&type=script&lang=js"
export * from "./confirmation-modal.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports